if (!customElements.get('cb-promo-carousel')) {
  customElements.define('cb-promo-carousel', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.setup());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.events?.abort();
      this.observer?.disconnect();
      this.events = null;
    }

    setup() {
      if (this.events) return;
      this.rail = this.querySelector('.cb-promo-grid__items');
      this.pagination = this.querySelector('[data-promo-pagination]');
      if (!this.rail || !this.pagination) return;
      this.cards = [...this.rail.children];
      this.dots = [...this.pagination.querySelectorAll('button')];
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const schedule = () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
      };
      this.rail.addEventListener('scroll', schedule, { ...options, passive: true });
      this.mobile.addEventListener('change', schedule, options);
      this.pagination.addEventListener('click', event => {
        const button = event.target.closest('button[data-promo-index]');
        if (button) this.go(Number(button.dataset.promoIndex));
      }, options);
      this.addEventListener('keydown', event => {
        if (this.pagination.hidden || (event.target !== this.rail && !this.pagination.contains(event.target))) return;
        let index = this.active || 0;
        if (event.key === 'ArrowRight') index++;
        else if (event.key === 'ArrowLeft') index--;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.cards.length - 1;
        else return;
        event.preventDefault();
        index = Math.max(0, Math.min(this.cards.length - 1, index));
        if (this.pagination.contains(event.target)) this.dots[index].focus({ preventScroll: true });
        this.go(index);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.cb-promo-grid__item');
        const index = this.cards.indexOf(card);
        if (index >= 0 && !this.pagination.hidden) this.go(index, true);
      }, options);
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(this.rail);
      this.update();
    }

    positions() {
      const left = this.rail.getBoundingClientRect().left;
      const padding = parseFloat(getComputedStyle(this.rail).paddingLeft) || 0;
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      return this.cards.map(card => Math.max(0, Math.min(max,
        this.rail.scrollLeft + card.getBoundingClientRect().left - left - padding)));
    }

    go(index, immediate = false) {
      if (this.pagination.hidden || !this.cards[index]) return;
      this.rail.scrollTo({ left: this.positions()[index], behavior: immediate || this.reduced.matches ? 'auto' : 'smooth' });
    }

    update() {
      const visible = this.mobile.matches && this.rail.scrollWidth > this.rail.clientWidth + 1;
      this.pagination.hidden = !visible;
      this.toggleAttribute('data-promo-paginated', visible);
      if (!visible) return;
      const positions = this.positions();
      this.active = positions.reduce((nearest, position, index) =>
        Math.abs(position - this.rail.scrollLeft) < Math.abs(positions[nearest] - this.rail.scrollLeft) ? index : nearest, 0);
      this.dots.forEach((dot, index) => {
        if (index === this.active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  });
}
